import { useContext} from "react";
import { UserContext } from '../../context/UserContext';
import { Roles } from '../../apollo/types/Roles';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Features } from '../../apollo/types/features';

export const Divertor = () => {
  const location = useLocation();
  const userContext = useContext(UserContext)
  let reviewScan = false
  if(userContext.organisation?.features?.length) {
    for (const feature of userContext.organisation.features) {
      if(feature.name === Features.PORTFOLIO_DASHBOARD && feature.status === 'ENABLED') {
        reviewScan = true;
      }
    }
  }

  if(!userContext) {
    return <Navigate to='/login' />
  }

  const isStartupRoute = location.pathname.endsWith('startup')
  const isRootPath = location.pathname === '/'
  if(userContext.role === Roles.STARTUP && (!isStartupRoute || isRootPath)) {
    // console.log('User is a startup')
    // return <Navigate to='/startup/startupaccount'  />
  }

  if(userContext.role !== Roles.STARTUP && (isStartupRoute || isRootPath)) {
    // console.log('User is not a startup')
    if(userContext?.organisation?.id === 1 || reviewScan) {
      return <Navigate to='/library/startups' />
    } else {
      return <Navigate to='/library/startups' />
    }
  }

  return (
      <>
        <Outlet />
      </>
  )
};
